var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalShippingFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.545 19.5a2.6 2.6 0 0 1-1.931-.82q-.796-.82-.796-1.992H2.91a.87.87 0 0 1-.648-.27A.92.92 0 0 1 2 15.75V6.375q0-.774.534-1.324T3.818 4.5h10.91q.75 0 1.283.55.535.552.535 1.325V8.25h1.818q.43 0 .818.2.386.198.636.55l2 2.742q.09.117.136.258.046.14.046.305v3.445a.92.92 0 0 1-.261.668.87.87 0 0 1-.648.27h-.91q0 1.17-.795 1.992a2.6 2.6 0 0 1-1.931.82 2.6 2.6 0 0 1-1.932-.82q-.795-.82-.796-1.992H9.273q0 1.17-.796 1.992a2.6 2.6 0 0 1-1.932.82m0-1.875q.387 0 .648-.27a.92.92 0 0 0 .262-.668.92.92 0 0 0-.262-.668.87.87 0 0 0-.648-.269.87.87 0 0 0-.647.27.92.92 0 0 0-.262.668q0 .398.262.668.261.27.647.269m10.91 0q.386 0 .647-.27a.92.92 0 0 0 .262-.668.92.92 0 0 0-.262-.668.87.87 0 0 0-.648-.269.87.87 0 0 0-.647.27.92.92 0 0 0-.261.668q0 .398.26.668.262.27.648.269m-.91-4.687h3.864l-2.045-2.813h-1.819z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalShippingFill);
export default __webpack_public_path__ + "static/media/local_shipping_fill.c19e3c622f2c50bec375eeceb19e7a97.svg";
export { ForwardRef as ReactComponent };